import { lighten, darken } from 'polished';

export const theme = {
  colors: {
    mainColor: '#FF557E',
    mainColorWithOpacity: lighten(0.4, '#FF557E'),
    secondaryColor: '#333333',
    secondaryColorWithOpacity: '#101410',
    darkPink: darken(0.1, '#FF557E'),
    rbmBlack: '#262424',
    rbmWhite: '#F8F8F8',
    mainColorButtonHover: '#7B98FE',
    warningColor: '#F29305',
    dangerColor: 'rgba(204, 33, 10, 1)',
  },
  fonts: {},
  spacings: {},
};
